/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CorsAllowedOriginEntity
 */
export interface CorsAllowedOriginEntity {
    /**
     * id
     * @type {string}
     * @memberof CorsAllowedOriginEntity
     */
    id: string;
    /**
     * 接続を許可するurl
     * @type {string}
     * @memberof CorsAllowedOriginEntity
     */
    url: string;
    /**
     * 説明
     * @type {string}
     * @memberof CorsAllowedOriginEntity
     */
    description: string;
}

/**
 * Check if a given object implements the CorsAllowedOriginEntity interface.
 */
export function instanceOfCorsAllowedOriginEntity(value: object): value is CorsAllowedOriginEntity {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function CorsAllowedOriginEntityFromJSON(json: any): CorsAllowedOriginEntity {
    return CorsAllowedOriginEntityFromJSONTyped(json, false);
}

export function CorsAllowedOriginEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): CorsAllowedOriginEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'url': json['url'],
        'description': json['description'],
    };
}

export function CorsAllowedOriginEntityToJSON(json: any): CorsAllowedOriginEntity {
    return CorsAllowedOriginEntityToJSONTyped(json, false);
}

export function CorsAllowedOriginEntityToJSONTyped(value?: CorsAllowedOriginEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'url': value['url'],
        'description': value['description'],
    };
}

